import React from 'react';
import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { ResponsiveTable } from "../../../layout/Table/ResponsiveTable";

function TableComponent(props) {
    return (
      <ResponsiveTable>
        <TableHead
          shouldRenderFields={props.shouldRenderFields}
          applySort={ props.applySort } />
        <TableBody
          shouldRenderFields={props.shouldRenderFields}
          orders={ props.orders }
          actionCallback={ props.actionCallback }
        />
      </ResponsiveTable>
    )
}

export { TableComponent };
